import PasswordRecoveryForm from './PasswordRecoveryForm';

export default PasswordRecoveryForm;
